import React from 'react'

interface CartoucheData {
  agence: string
  client: string
  evenement: string
  lieu: string
  suite: string
  quoi: string
  legende: string
  date: string
  de: string
}

interface SvgCartoucheProps {
  cartouche: CartoucheData
  t: (key: string) => string
}

const SvgCartouche = React.memo(function SvgCartouche({ cartouche, t }: SvgCartoucheProps) {
  return (
    <g>
      {/* Fond du cartouche */}
      <rect
        x="-426.45"
        y="269.35"
        width="852.9"
        height="23.65"
        fill="white"
        stroke="black"
        strokeWidth="0.5"
        opacity="0.95"
      />

      {/* Lignes de séparation verticales - 8 colonnes selon l'image */}
      <line x1="-320" y1="269.35" x2="-320" y2="293" stroke="black" strokeWidth="0.3" />
      <line x1="-213" y1="269.35" x2="-213" y2="293" stroke="black" strokeWidth="0.3" />
      <line x1="-106" y1="269.35" x2="-106" y2="293" stroke="black" strokeWidth="0.3" />
      <line x1="1" y1="269.35" x2="1" y2="293" stroke="black" strokeWidth="0.3" />
      <line x1="108" y1="269.35" x2="108" y2="293" stroke="black" strokeWidth="0.3" />
      <line x1="215" y1="269.35" x2="215" y2="293" stroke="black" strokeWidth="0.3" />
      <line x1="322" y1="269.35" x2="322" y2="293" stroke="black" strokeWidth="0.3" />

      {/* Labels et valeurs du cartouche */}
      {/* Agence/Client */}
      <text x="-423" y="277" fontFamily="Arial, sans-serif" fontSize="5" fill="black" fontWeight="bold">{t('synoptic.agency')} :</text>
      <text x="-423" y="285" fontFamily="Arial, sans-serif" fontSize="5" fill="black">{cartouche.agence}</text>
      <text x="-423" y="290" fontFamily="Arial, sans-serif" fontSize="5" fill="black">{cartouche.client}</text>

      {/* Événement */}
      <text x="-317" y="277" fontFamily="Arial, sans-serif" fontSize="5" fill="black" fontWeight="bold">{t('synoptic.event')} :</text>
      <text x="-317" y="285" fontFamily="Arial, sans-serif" fontSize="5" fill="black">{cartouche.evenement}</text>

      {/* Lieu */}
      <text x="-210" y="277" fontFamily="Arial, sans-serif" fontSize="5" fill="black" fontWeight="bold">{t('synoptic.location')} :</text>
      <text x="-210" y="285" fontFamily="Arial, sans-serif" fontSize="5" fill="black">{cartouche.lieu}</text>

      {/* Suite */}
      <text x="-103" y="277" fontFamily="Arial, sans-serif" fontSize="5" fill="black" fontWeight="bold">{t('synoptic.suite')} :</text>
      <text x="-103" y="285" fontFamily="Arial, sans-serif" fontSize="5" fill="black">{cartouche.suite}</text>

      {/* Quoi */}
      <text x="4" y="277" fontFamily="Arial, sans-serif" fontSize="5" fill="black" fontWeight="bold">{t('synoptic.what')} :</text>
      <text x="4" y="285" fontFamily="Arial, sans-serif" fontSize="5" fill="black">{cartouche.quoi}</text>

      {/* Légende synoptique */}
      <text x="111" y="277" fontFamily="Arial, sans-serif" fontSize="5" fill="black" fontWeight="bold">{t('synoptic.legend')} :</text>
      <text x="111" y="285" fontFamily="Arial, sans-serif" fontSize="5" fill="black">{cartouche.legende}</text>

      {/* Date */}
      <text x="218" y="277" fontFamily="Arial, sans-serif" fontSize="5" fill="black" fontWeight="bold">{t('synoptic.date')} :</text>
      <text x="218" y="285" fontFamily="Arial, sans-serif" fontSize="5" fill="black">{cartouche.date}</text>

      {/* De */}
      <text x="325" y="277" fontFamily="Arial, sans-serif" fontSize="5" fill="black" fontWeight="bold">{t('synoptic.from')} :</text>
      <text x="325" y="285" fontFamily="Arial, sans-serif" fontSize="5" fill="black">{cartouche.de}</text>
    </g>
  )
})

export default SvgCartouche
